// extracted by mini-css-extract-plugin
export var active = "FavoriteCount-module--active--JSto9";
export var animate = "FavoriteCount-module--animate--CUv3t";
export var badge = "FavoriteCount-module--badge--hY3to";
export var number = "FavoriteCount-module--number--l6Neb";
export var pulse = "FavoriteCount-module--pulse--TDPkQ";
export var wrapper = "FavoriteCount-module--wrapper--ZmZdF";